var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg500(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 194 281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.611 280.227H.251c.818-21.034 13.744-30.022 33.455-30.519 13.011-35.245 41.52.713 43.573-27.166 2.41-32.785 3.104-71.426 3.104-71.426l16.808.278s1.403 20.687 4.316 62.834c2.065 29.853 23.104 2.167 50.74 20.259 13.95 9.133 13.328 31.227 13.328 31.227s12.036.603 12.036 14.513z",
    fill: "#B5B8BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.19 280.227H17.685c1.892-9.328 9.971-16.132 19.488-17.065 1.825-.173 3.7-.137 5.597.138 1.092.161 2.154.391 3.182.694a22.278 22.278 0 017.557 3.897c3.94 3.106 6.689 7.466 7.68 12.336zM157.877 280.227h-23.542c.965-4.292 4.037-7.769 8.079-9.09.952-.311 1.96-.504 3.008-.557a11.355 11.355 0 011.783.045c5.13.521 9.416 4.406 10.672 9.602z",
    fill: "#D7DADD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.6 280.227H52.326a31.15 31.15 0 01.223-8.145c.228-1.433.552-2.834.961-4.191 4.653-15.369 20.589-25.432 37.548-22.961a34.735 34.735 0 0111.105 3.582c11.662 6.089 18.857 18.462 17.437 31.715zM66.184 219.105c-.552 3.474-3.938 5.861-7.563 5.333-3.626-.528-6.118-3.774-5.566-7.247.551-3.474 3.938-5.861 7.563-5.333 3.626.529 6.118 3.773 5.566 7.247zM114.396 220.312c-.227 1.433-1.625 2.418-3.122 2.2-1.496-.218-2.525-1.557-2.297-2.991.228-1.433 1.626-2.419 3.122-2.2 1.496.218 2.524 1.556 2.297 2.991zM193.23 263.968c-.525 3.308-3.751 5.582-7.203 5.078-3.453-.503-5.827-3.593-5.302-6.902.527-3.308 3.751-5.582 7.204-5.078 3.453.503 5.827 3.593 5.301 6.902z",
    fill: "#D7DADD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.365 138.677h40.158c2.327 0 4.215-1.809 4.215-4.039 0-2.23-1.888-4.038-4.215-4.038H69.365c-2.328 0-4.215 1.808-4.215 4.038 0 2.23 1.887 4.039 4.215 4.039zm8.927 17.024h22.304l8.43-17.024H69.862l8.43 17.024z",
    fill: "#4D3BD7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.402,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.526 155.7H78.221l-8.43-17.024h39.164l-8.429 17.024z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.479 238.883l-8.882-9.623 12.877-16.535 15.46 13.4-5.576 11.765M135.934 238.089l-7.962-10.395 14.339-15.287 14.165 14.76-6.63 11.205",
    stroke: "#0B0826",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.47 168.698l-6.384-46.759M40.525 167.272l6.729-46.708",
    stroke: "#0B0826",
    strokeWidth: 27,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.733 141.206H97.561a4.901 4.901 0 01-4.902-4.899V118.15a4.9 4.9 0 014.902-4.897h18.172a4.9 4.9 0 014.903 4.897v18.157a4.901 4.901 0 01-4.903 4.899z",
    fill: "#0B0826"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.097 141.206H97.561a4.901 4.901 0 01-4.902-4.899V118.15a4.9 4.9 0 014.902-4.897h13.536A4.9 4.9 0 01116 118.15v18.157a4.901 4.901 0 01-4.903 4.899z",
    fill: "#4D3BD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.996 135.502c-.128.003-.256.004-.384.004-8.447 0-15.295-6.842-15.295-15.282 0-8.439 6.848-15.281 15.295-15.281 1.804 0 3.535.312 5.142.885 7.537-13.55 22.008-22.718 38.623-22.718 15.848 0 29.747 8.343 37.536 20.872a15.306 15.306 0 014.923-.809c8.448 0 15.295 6.842 15.295 15.282 0 8.027-6.194 14.609-14.067 15.233-3.128 21.303-21.495 37.659-43.687 37.659-21.557 0-39.506-15.434-43.381-35.845zm-26.641 42.197c-.464-6.21 4.199-11.62 10.414-12.083l15.616-1.165c6.216-.463 11.63 4.196 12.094 10.405l2.656 35.566c.464 6.209-4.199 11.62-10.414 12.083l-15.616 1.165c-6.216.463-11.63-4.196-12.094-10.407l-2.656-35.564zm113.187-14.012c-6.232-.034-11.312 4.988-11.345 11.215l-.19 35.663c-.034 6.228 4.992 11.303 11.225 11.337l15.659.083c6.233.033 11.313-4.988 11.346-11.217l.19-35.662c.033-6.227-4.993-11.302-11.225-11.336l-15.66-.083z",
    fill: "#4D3BD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.516 86.48h33.722V75.335H74.516V86.48zM111.426 147.388c2.542 0 4.602-3.125 4.602-6.982v-25.88c0-3.855-2.06-6.981-4.602-6.981h4.351c2.542 0 4.602 3.126 4.602 6.981v25.88c0 3.857-2.06 6.982-4.602 6.982h-4.351z",
    fill: "#0B0826"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.402,
    d: "M32.53 176.641l-4.464.353 4.463-.353zm-4.816-4.115l.352 4.468-.352-4.468zm7.619 39.69l4.463-.353-4.463.353zm-4.111 4.821l-.352-4.469.352 4.469zm-4.815-4.116l-4.463.352 4.463-.352zm-2.804-35.574l-4.463.352 4.463-.352zm15.875-1.299l-4.463.352 4.463-.352zm-4.815-4.116l.352 4.468-.352-4.468zm7.619 39.691l4.463-.353-4.463.353zm-8.926.705l4.463-.352-4.463.352zm-2.804-35.575l-4.463.353 4.463-.353zm6.44-.464c-.389-4.936-4.7-8.621-9.63-8.232l.704 8.937 8.926-.705zm2.804 35.574l-2.804-35.574-8.926.705 2.804 35.574 8.926-.705zm-8.222 9.642c4.93-.389 8.61-4.706 8.222-9.642l-8.926.705.704 8.937zm-9.63-8.232c.389 4.936 4.7 8.622 9.63 8.232l-.704-8.937-8.926.705zm-2.804-35.574l2.804 35.574 8.926-.705-2.804-35.574-8.926.705zm8.222-9.642c-4.93.39-8.61 4.707-8.222 9.642l8.926-.705-.704-8.937zm16.58 7.638c-.39-4.935-4.701-8.621-9.63-8.232l.703 8.937 8.926-.705zm2.803 35.575l-2.803-35.575-8.927.705 2.804 35.576 8.926-.706zm-8.222 9.642c4.93-.389 8.611-4.706 8.222-9.642l-8.926.706.704 8.936zm-9.63-8.231c.389 4.935 4.7 8.621 9.63 8.231l-.704-8.936-8.926.705zm-2.804-35.575l2.804 35.575 8.926-.705-2.804-35.576-8.926.706zm8.222-9.643c-4.93.39-8.61 4.707-8.222 9.643l8.926-.706-.704-8.937z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.686 148.178H83.3c-5.078 0-9.195-3.187-9.195-7.12v-26.393c0-3.933 4.117-7.12 9.195-7.12h25.386c5.078 0 9.193 3.187 9.193 7.12v26.393c0 3.933-4.115 7.12-9.193 7.12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.404,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.86 120.096c0 8.439 6.847 15.281 15.294 15.281s15.295-6.842 15.295-15.281c0-8.44-6.848-15.282-15.295-15.282s-15.295 6.842-15.295 15.282z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.399,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.507 174.983l-.19 35.663c-.033 6.227 4.993 11.302 11.225 11.336l15.66.084c6.233.033 11.312-4.989 11.345-11.217l.19-35.662c.033-6.227-4.993-11.302-11.225-11.336l-15.659-.083c-6.233-.034-11.313 4.987-11.346 11.215z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.398,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.796 104.148a15.302 15.302 0 014.923-.809c8.447 0 15.295 6.843 15.295 15.282 0 8.028-6.194 14.609-14.068 15.234.31-2.109.47-4.266.47-6.459a43.893 43.893 0 00-6.62-23.248z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.564 127.965h11.441V116.51c-6.319 0-11.44 5.129-11.44 11.455z",
    fill: "#614FE7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.005 120.805v7.16h7.151c0-3.955-3.201-7.16-7.15-7.16z",
    fill: "#8E82EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.446 127.965h-11.44v11.455c6.318 0 11.44-5.129 11.44-11.455z",
    fill: "#614FE7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.005 139.42v-11.455h-11.44c0 6.326 5.121 11.455 11.44 11.455z",
    fill: "#4D3BD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.668 49.282V19.87",
    stroke: "#0B0826",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.318 61.766h-12.173V43.639h12.173c4.989 0 9.071 4.078 9.071 9.063s-4.082 9.064-9.071 9.064z",
    fill: "#0B0826"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.143 14.099a6.58 6.58 0 016.526-5.718 6.578 6.578 0 016.581 6.577 6.578 6.578 0 01-6.581 6.576 6.584 6.584 0 01-5.988-3.842l-4.59-3.509-6.246 4.775-6.241-4.775-6.243 4.775-6.242-4.775-6.243 4.775-3.446-2.636a6.582 6.582 0 01-6.44 5.212 6.58 6.58 0 01-6.581-6.576A6.58 6.58 0 0166.99 8.38a6.584 6.584 0 016.294 4.648l3.591 2.747L83.12 11l6.242 4.775L95.604 11l6.241 4.775 6.246-4.774 4.052 3.097zm4.149 61.062H68.915a6.827 6.827 0 01-6.83-6.824v-31.27a6.827 6.827 0 016.83-6.823h47.377a6.827 6.827 0 016.829 6.824v31.27a6.827 6.827 0 01-6.829 6.823zm-42.962 6.19h38.545a3.095 3.095 0 100-6.19H73.33a3.096 3.096 0 00-3.097 3.095 3.096 3.096 0 003.097 3.095z",
    fill: "#4D3BD7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.404,
    d: "M83.12 14.183l-6.244 4.775-3.445-2.61-.163-3.33 3.608 2.758 6.243-4.774 6.242 4.774 6.243-4.774 6.241 4.774 6.246-4.774 3.996 3.181.665 3.53-4.661-3.53-6.246 4.775-6.241-4.775-6.243 4.775-6.242-4.775z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.396,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.875 81.35H73.33a3.096 3.096 0 01-3.097-3.094 3.096 3.096 0 013.097-3.095h38.545a3.095 3.095 0 110 6.19z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.897 61.766h12.171V43.639H59.897c-4.99 0-9.072 4.078-9.072 9.063s4.082 9.064 9.072 9.064zM118.668 52.702c0 6.932-4.493 12.55-10.034 12.55S98.6 59.635 98.6 52.703c0-6.931 4.493-12.55 10.034-12.55s10.034 5.619 10.034 12.55z",
    fill: "#0B0826"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.918 65.253h4.716V40.152h-4.716v25.1z",
    fill: "#0B0826"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.954 52.702c0 6.932-4.493 12.55-10.036 12.55-5.541 0-10.034-5.618-10.034-12.55 0-6.931 4.493-12.55 10.034-12.55 5.543 0 10.036 5.619 10.036 12.55z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.056 51.86c0 2.44-1.582 4.418-3.533 4.418-1.951 0-3.532-1.978-3.532-4.418 0-2.44 1.581-4.418 3.532-4.418s3.533 1.978 3.533 4.418z",
    fill: "#0B0826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.99 49.282V21.225",
    stroke: "#0B0826",
    strokeWidth: 7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .964)",
    d: "M0 0h194v279.9H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.12bf5aec.svg";
export { ForwardRef as ReactComponent };